// Barre d'accès en pied de carte : les sections du lead, dans l'ordre des
// onglets du panneau, avec leur compteur ou leur état (`extra`, par onglet).
const BarreAcces = ({ onglets = [], extra = {}, nom, panneauCarte }) => {
  const { estOuvert, onglet, ouvrir } = panneauCarte;

  return (
    <nav className="la-acces" aria-label={`Détail du lead ${nom}`}>
      {onglets.map((o) => (
        <button
          key={o.id}
          type="button"
          className="la-acces__bouton"
          data-la-onglet={o.id}
          aria-current={estOuvert && onglet === o.id ? "true" : undefined}
          onClick={() => ouvrir(o.id)}
        >
          <i className={`fa ${o.icone}`} aria-hidden="true" />
          {o.libelle}
          {extra[o.id]}
        </button>
      ))}
    </nav>
  );
};

export default BarreAcces;
